import { CButton, CButtonGroup, CTooltip } from "@coreui/react";
import EconomicActivity from "../../models/economic-activity";

interface EconomicActivityCrudAtionsProps {
  economicActivity: EconomicActivity;
  onUpdateClick: (_: EconomicActivity) => void;
  onDeleteClick: (_: EconomicActivity) => void;
  isDemo?: boolean;
}

const EconomicActivityCrudActions: React.FC<
  EconomicActivityCrudAtionsProps
> = ({ economicActivity, onUpdateClick, onDeleteClick, isDemo }) => {
  const editButton = (
    <CTooltip content="Editar">
      <CButton
        className="text-white"
        color="warning"
        onClick={() => {
          onUpdateClick(economicActivity);
        }}
      >
        <i className="fa fa-pencil"></i>
      </CButton>
    </CTooltip>
  );

  const deleteButton = (
    <CTooltip content="Eliminar">
      <CButton
        className="text-white"
        color="danger"
        onClick={() => {
          onDeleteClick(economicActivity);
        }}
      >
        <i className="fa fa-trash"></i>
      </CButton>
    </CTooltip>
  );

  return (
    <td className="text-center">
      <CButtonGroup>
        {!isDemo && economicActivity.canBeModified ? editButton : null}
        {!isDemo && economicActivity.canBeDeleted ? deleteButton : null}
      </CButtonGroup>
    </td>
  );
};

export default EconomicActivityCrudActions;
